export default __webpack_public_path__ + "static/media/press-01.884d7b8a.jpg";